import { render, staticRenderFns } from "./living_settlement.vue?vue&type=template&id=4090e3bb&scoped=true&"
import script from "./living_settlement.vue?vue&type=script&lang=js&"
export * from "./living_settlement.vue?vue&type=script&lang=js&"
import style0 from "./living_settlement.vue?vue&type=style&index=0&id=4090e3bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4090e3bb",
  null
  
)

export default component.exports